import React, { useState } from "react";
import AddTicketComponent from "./AddTicketComponent";
import Tooltip from "./Dashboard/Tooltip";

function Step3Form(props) {
    const {
        prevPage,
        nextPage,
        handleTicketsDataChange,
        ticketsData,
        // tickets,
        setTicketsData,
        setFormData,
        // setTickets,
    } = props;
    const [ShowMyModal, setShowMyModal] = useState(false);
    const [addModal, setShowAddModal] = useState(false);
    const handleOnClose = () => setShowMyModal(false);
    const handleOnAddModalClose = () => setShowAddModal(false);
    const [isAddButtonDisabled, setIsAddButtonDisabled] = useState(false);
    const [errors, setErrors] = useState({});
    const [showComments, setShowComments] = useState([]);

    const handleRemoveTicket = (index) => {

        const updatedTickets = ticketsData.filter((_, i) => i !== index);

        setTicketsData(updatedTickets);
        setFormData((prevData) => ({ ...prevData, tickets: updatedTickets }));

        // Réévaluez si le bouton doit être réactivé
        if (updatedTickets.length < 5) {
            setIsAddButtonDisabled(false);
        }
    };

    const handleAddNewTicket = (e) => {

        e.preventDefault();

        // Vérifie le nombre actuel de tickets valides
        const validTicketsCount = ticketsData.filter(
            (ticket) => ticket.nom && ticket.prix_unitaire && ticket.quantite && ticket.comment
        ).length;

        if (validTicketsCount >= 5) {
            setIsAddButtonDisabled(true); // Désactive le bouton
            return; // Empêche l'ouverture du modal
        }

        // Permet l'ajout d'un nouveau ticket
        setShowAddModal(true);
    };

    const handleConfirmAddTicket = () => {
        setShowMyModal(false);
        setShowAddModal(false);
    };

    const handleCancelAddTicket = () => {
        setShowMyModal(false);
    };

    const toggleCommentField = (index) => {
        setShowComments((prevShowComments) => {
            const updated = [...prevShowComments];
            updated[index] = !updated[index];
    
            // Si on masque le champ de commentaire, réinitialiser le contenu
            if (!updated[index]) {
                setTicketsData((prevTicketsData) => {
                    const updatedTickets = [...prevTicketsData];
                    updatedTickets[index] = {
                        ...updatedTickets[index],
                        comment: "", // Réinitialise le champ comment
                    };
                    return updatedTickets;
                });

                setErrors((prevErrors) => {
                    const updatedErrors = { ...prevErrors };
                    delete updatedErrors[`comment${index}`]; // Supprime l'erreur associée
                    return updatedErrors;
                });
            }
    
            return updated;
        });
    };

    const handleInputChange = (e, index) => {
        handleTicketsDataChange(e, index);
        // Clear the error associated with the changed field
        setErrors((prevErrors) => ({
            ...prevErrors,
            [e.target.name]: undefined,
        }));
    };

    const validateForm = async () => {
        const newErrors = {};
        // Validation pour chaque billet
        ticketsData.forEach((ticket, index) => {
            if (!ticket.nom.trim()) {
                newErrors[`nom${index}`] = "Ce champ est requis";
            } else if (!/^[a-zA-ZÀ-ÖØ-öø-ÿ0-9\s'-]+$/.test(ticket.nom)) {
                newErrors[`nom${index}`] = "Le nom ne doit pas contenir de caractères spéciaux.";
            }

            const prixTicket = parseInt(ticket.prix_unitaire, 10);
            if (!ticket.prix_unitaire /* .trim() */) {
                newErrors[`prix_unitaire${index}`] = "Ce champ est requis";
            } else if (!/^\d+$/.test(ticket.prix_unitaire)) {
                newErrors[`prix_unitaire${index}`] = "Veuillez entrer un prix valide.";
            } else if (prixTicket < 500) {
                newErrors[`prix_unitaire${index}`] = "Le prix doit être supérieur ou égal à 500 XOF.";
            }

            const quantiteNum = parseInt(ticket.quantite, 10);
            if (!ticket.quantite /* .trim() */) {
                newErrors[`quantite${index}`] = "Ce champ est requis";
            } else if (!/^\d+$/.test(ticket.quantite)) {
                newErrors[`quantite${index}`] = "Veuillez entrer une quantité valide.";
            } else if (quantiteNum < 15) {
                newErrors[`quantite${index}`] = "La quantité doit être d'au moins 15.";
            }

            if (showComments[index]) {
                if (!ticket.comment || ticket.comment.trim() === "") {
                    newErrors[`comment${index}`] = "Ce champ est requis";
                } else if (ticket.comment.length > 500) {
                    newErrors[`comment${index}`] = "Le commentaire ne doit pas dépasser 500 caractères.";
                }
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
        if (await validateForm()) {
            nextPage();
        }
    };

    return (
        <div className="nc-PageAddListing1 px-4 max-w-3xl mx-auto pb-10 pt-14">
            <div className="space-y-11">
                <div>
                    <span className="text-4xl font-semibold">2</span>{" "}
                    <span className="text-lg text-neutral-500 dark:text-neutral-400">
                        / 2
                    </span>
                </div>
                <AddTicketComponent
                    visible={addModal}
                    onClose={handleOnAddModalClose}
                    onConfirm={handleConfirmAddTicket}
                    handleTicketsDataChange={handleTicketsDataChange}
                    ticketsData={ticketsData}
                    setFormData={setFormData}
                    setTicketsData={setTicketsData}
                />
                <div className="listingSection__wrap">
                    <h2 className="text-2xl font-semibold text-gray-700">
                        TICKETS D'ENTREES
                    </h2>
                    <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />
                    {ticketsData.map(
                        (ticket, index) =>
                            ticket && (
                                <div key={index}>
                                    <div className="flex items-center justify-between">
                                        
                                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-5 mb-3 w-full">
                                            <div className="">
                                                <label className="nc-Label text-sm font-medium text-neutral-700 dark:text-neutral-300 ">
                                                    Type de ticket
                                                </label>
                                                <div className="mt-1">
                                                    <input
                                                        onChange={(e) => handleTicketsDataChange(e, index)}
                                                        name={`nom`}
                                                        type="text"
                                                        required
                                                        defaultValue={ticketsData[index]?.nom}
                                                        placeholder={"(ex: VIP)"}
                                                        className="block w-full uppercase border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900 rounded-2xl text-sm font-normal h-11 px-4 py-3 "
                                                    />
                                                    {errors[`nom${index}`] && (
                                                        <small className="text-red-600 mt-2">
                                                            {errors[`nom${index}`]}
                                                        </small>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="">
                                                <label className="nc-Label text-sm font-medium text-neutral-700 dark:text-neutral-300 ">
                                                    Prix unitaire
                                                </label>
                                                <div className="mt-1 relative">
                                                    <input
                                                        onChange={(e) => handleTicketsDataChange(e, index)}
                                                        name={`prix_unitaire`}
                                                        placeholder={"(ex: 10 000)"}
                                                        type="number"
                                                        required
                                                        defaultValue={ticketsData[index]?.prix_unitaire}
                                                        className="block w-full border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900 rounded-2xl text-sm font-normal h-11 px-4 py-3 "
                                                    />
                                                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                                        <small className="text-gray-500">XOF</small>
                                                    </div>
                                                </div>
                                                {errors[`prix_unitaire${index}`] && (
                                                    <small className="text-red-600 mt-2">
                                                        {errors[`prix_unitaire${index}`]}
                                                    </small>
                                                )}
                                            </div>
                                            <div className="">
                                                <label className="nc-Label text-sm font-medium text-neutral-700 dark:text-neutral-300 ">
                                                    Quantité
                                                </label>
                                                <div className="mt-1 relative">
                                                    <input
                                                        onChange={(e) => handleTicketsDataChange(e, index)}
                                                        name={`quantite`}
                                                        type="number"
                                                        required
                                                        defaultValue={ticketsData[index]?.quantite}
                                                        placeholder={"(min: 15)"}
                                                        className="block w-full border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900 rounded-2xl text-sm font-normal h-11 px-4 py-3 "
                                                    />
                                                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                                        <small className="text-gray-500">tickets</small>
                                                    </div>
                                                </div>
                                                {errors[`quantite${index}`] && (
                                                    <small className="text-red-600 mt-2">
                                                        {errors[`quantite${index}`]}
                                                    </small>
                                                )}
                                            </div>
                                        </div>
                                        {index !== 0 && (
                                            <i
                                                className="text-2xl text-neutral-400 las la-times-circle hover:text-neutral-900 dark:hover:text-neutral-100 cursor-pointer"
                                                style={{ marginLeft: "8px", marginTop: "5px" }}
                                                onClick={() => handleRemoveTicket(index)}
                                            />
                                        )}
                                    </div>
                                    <div className="inline-flex items-center">
                                        <button
                                            onClick={() => toggleCommentField(index)}
                                            type="button"
                                            className="inline-flex items-center w-full sm:w-auto text-sm text-blue-400 hover:text-blue-500 transition cc0oq cghq3 c0zkc"
                                        >
                                            
                                            
                                            {showComments[index] ? 
                                            <>
                                            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" width={24} height={24}>
                                                <path d="M17,17 C17,18.6568542 15.6568542,20 14,20 L9,20 C7.34314575,20 6,18.6568542 6,17 L6,7 L5,7 L5,6 L18,6 L18,7 L17,7 L17,17 Z M9,9 L10,9 L10,16 L9,16 L9,9 Z M11,9 L12,9 L12,16 L11,16 L11,9 Z M13,9 L14,9 L14,16 L13,16 L13,9 Z M7,17 C7,18.1045695 7.8954305,19 9,19 L14,19 C15.1045695,19 16,18.1045695 16,17 L16,7 L7,7 L7,17 Z M13,6 L13,5 L10,5 L10,6 L9,6 L9,5 C9,4.44771525 9.44771525,4 10,4 L13,4 C13.5522847,4 14,4.44771525 14,5 L14,6 L13,6 Z" />
                                            </svg>
                                            Retirer le commentaire
                                            </>
                                            : 
                                            <>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="currentColor"
                                                    aria-hidden="true"
                                                    className="w-4 h-4"
                                                >
                                                    <path
                                                        fill-rule="evenodd"
                                                        d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z"
                                                        clip-rule="evenodd"
                                                    ></path>
                                                </svg>
                                                Ajouter un commentaire
                                            </>
                                            }
                                        </button>
                                        <Tooltip className="ml-2" bg={'dark'} size="md" position={'top'}>
                                            <div className="text-xs">Ce champ vous permet d'ajouter des remarques spécifiques liées à ce ticket d'entrée. Les commentaires sont facultatifs, mais peuvent être utiles pour fournir des informations supplémentaires ou signaler des points importants et s'affichera lors des achats.</div>
                                        </Tooltip>
                                    </div>
                                    {showComments[index] && (
                                        <>
                                            <textarea
                                                id="comment"
                                                className="cn9r8 c071z c6btv cgk1f"
                                                rows={2}
                                                placeholder="Saisissez votre commentaire"
                                                onChange={(e) => handleInputChange(e, index)}
                                                name={`comment`}
                                                value={ticketsData[index]?.comment || ""}
                                                maxLength={500}
                                            />
                                            {errors[`comment${index}`] && (
                                                <small className="text-red-600 mt-2">
                                                    {errors[`comment${index}`]}
                                                </small>
                                            )}
                                        </>
                                    )}
                                </div>
                            )
                    )}

                    <div className="flex justify-end">
                        <button
                            disabled={ticketsData.length >= 5 || isAddButtonDisabled}
                            onClick={handleAddNewTicket}
                            className="mr-4 w-full px-3 sm:ml-3 sm:w-auto text-sm font-medium sm:px-6 border-gray-200 text-gray-800 cc0oq cghq3 cspbm c0zkc cnf4p"
                        >
                            Ajouter
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                aria-hidden="true"
                                className="w-4 h-4"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                        </button>
                    </div>
                </div>

                <div className="flex justify-end space-x-5">
                    <button
                        type="button"
                        onClick={prevPage}
                        className="nc-Button relative h-auto inline-flex items-center justify-center rounded-lg transition-colors text-sm sm:text-base font-medium px-2 py-2 sm:px-4 ttnc-ButtonSecondary font-medium border bg-white border-neutral-200 text-neutral-700 dark:bg-neutral-900 dark:text-neutral-300 dark:border-neutral-700 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                    >
                        Précédent
                    </button>
                    <button
                        type="button"
                        onClick={handleSubmit}
                        className="nc-Button relative h-auto inline-flex items-center justify-center rounded-lg transition-colors text-sm sm:text-base font-medium px-2 py-2 sm:px-4 ttnc-ButtonPrimary disabled:bg-opacity-70 bg-primary-6000 hover:bg-primary-700 text-neutral-50   "
                    >
                        Terminer
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Step3Form;
